import React from "react";
import SliderCard from "./SliderCard";

function Slider() {
  return (
    <>
      <section className=" ">
        <div className="">
          <SliderCard />
        </div>
      </section>
    </>
  );
}

export default Slider;
